import useLogin, { CURRENT_USER_ROLE, CURRENT_USER_COMPANY } from '../../hooks/useLogin';
import Navigator from '../../components/Navigator';
import React, { useEffect, useState } from 'react';
import { type User } from '../../utils/type';
import { Box } from '@mui/system';
import { contentSx, titleSx, userDialogSx } from './styles';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { UserList } from './UserList';
import { type AxiosResponse } from 'axios';
import Bg from '../../assets/login-background.png';
import UserDialog from './UserDialog';
import Copyright from '../../components/Copyright';
import { getUser } from '../../api/apis';

import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export const UserListPage = () => {
  const { t } = useTranslation();
  useLogin();
  const [users, setUsers] = useState<User[]>([]);
  const [isDialogVisible, toggleDialog] = useState(false);
  const currentRole = sessionStorage.getItem(CURRENT_USER_ROLE);
  const currentCompany = sessionStorage.getItem(CURRENT_USER_COMPANY);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  // const [inactiveMsg, setInactiveMsg] = useState('');

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    // NOTE: API works only at production site due to CORS issue
    ; (async () => {
      if (currentRole === 'platform-admin' && sessionStorage.getItem('IsCheckInactive') === '0') {
        sessionStorage.setItem('IsCheckInactive', '1');
        // await handleCheckInactive();
      }
      let emails;
      if (sessionStorage.getItem(CURRENT_USER_ROLE) === 'platform-admin') {
        emails = await getUser({ email: 'all' });

        const newUsers = await getUser({ email: emails.data.user.join('!') });

        const usersAdapter = [];
        newUsers.data.user.forEach(e => {
          usersAdapter.push({
            value: {
              data: {
                user: e,
              },
            },
          });
        });

        const mergesUsers = usersAdapter.map((user, idx) => {
          const userData = (user as PromiseFulfilledResult<AxiosResponse>).value.data.user;
          // loginHistory might be null due to database inconsistency
          const historyData = userData.login_history.history.length > 0 ? userData.login_history.history[0] : { login: '', logout: '' };
          return { ...userData, ...historyData };
        });

        setUsers(
          mergesUsers.sort((a: User, b: User) => {
            if (a.uid > b.uid) return 1;
            else if (a.uid === b.uid) return 0;
            return -1;
          }),
        );
      } else {
        const newUsers = await getUser({ company_id: currentCompany });

        const usersAdapter = [];
        newUsers.data.user.forEach(e => {
          usersAdapter.push({
            value: {
              data: {
                user: e,
              },
            },
          });
        });

        const mergesUsers = usersAdapter
          .filter((user) => {
            const roleFilter = (user as PromiseFulfilledResult<AxiosResponse>).value.data.user?.role !== null ? (user as PromiseFulfilledResult<AxiosResponse>).value.data.user.role : '';
            return !(roleFilter === 'platform-admin');
          })
          .map((user) => {
            const userData = (user as PromiseFulfilledResult<AxiosResponse>).value.data.user;
            // loginHistory might be null due to database inconsistency
            const historyData = userData.login_history.history.length > 0 ? userData.login_history.history[0] : { login: '', logout: '' };
            return { ...userData, ...historyData };
          });

        setUsers(
          mergesUsers.sort((a: User, b: User) => {
            if (a.uid > b.uid) return 1;
            else if (a.uid === b.uid) return 0;
            return -1;
          }),
        );
      }
    })();
  }, []);

  const afterAddUser = (newUser: User) => {
    setUsers(prev => [newUser, ...prev]);
  };

  return (
    <main style={{
      width: '100vw',
      minHeight: '1000px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      background: `url(${Bg}) no-repeat center center`,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      position: 'inherit',
    }}>
      <Navigator />
      <div
        style={{
          display: 'flex',
          height: '1000px',
        }}
      >
        <Box sx={contentSx}>
          <Box sx={titleSx}>
            <div>
              <span className="title">{t('User List')}</span>
              <span className="subTitle">{t('Admin')}</span>
            </div>
            <div className="second-row">
              <Button
                variant="contained"
                startIcon={<i className="bi bi-plus-lg"></i>}
                style={{ textTransform: 'none' }}
                onClick={() => { toggleDialog(true); }}
              >
                {t('Add user')}
              </Button>
            </div>
          </Box>

          <UserList users={users} setUsers={setUsers} />
        </Box>
      </div>

      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          sx={userDialogSx}
          maxWidth="md"
        >
          <DialogContent>
            <div className="confirm-row" style={{
              color: '#006EC2',
              justifyContent: 'center',
              fontWeight: 'bold',
              paddingTop: '40px',
            }}>
              {/* {inactiveMsg} */}
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClose}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Copyright />

      {isDialogVisible && <UserDialog userData={null} onClose={() => { toggleDialog(false); }} afterAddUser={afterAddUser} />}
    </main>
  );
};

export default UserListPage;
